"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CellSorter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CellSorter = /*#__PURE__*/function (_Component) {
  _inherits(CellSorter, _Component);

  var _super = _createSuper(CellSorter);

  function CellSorter() {
    _classCallCheck(this, CellSorter);

    return _super.apply(this, arguments);
  }

  _createClass(CellSorter, [{
    key: "updateSort",
    value: function updateSort() {
      var _this$props = this.props,
          sortBy = _this$props.sortBy,
          sortTable = _this$props.sortTable,
          actionType = _this$props.actionType,
          _this$props$sortFilte = _this$props.sortFilters,
          sortOrder = _this$props$sortFilte.sortOrder,
          currentSectionSort = _this$props$sortFilte.sortBy;
      var nextOrder;

      if (sortBy === currentSectionSort) {
        nextOrder = sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        nextOrder = 'desc';
      }

      sortTable(sortBy, nextOrder, actionType);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      // for sort handling
      var _this$props2 = this.props,
          sortBy = _this$props2.sortBy,
          currentSectionSort = _this$props2.sortFilters.sortBy,
          rank = _this$props2.rank; // for passing down to the Cell

      var _this$props3 = this.props,
          highlighted = _this$props3.highlighted,
          header = _this$props3.header,
          headerText = _this$props3.headerText,
          type = _this$props3.type,
          data = _this$props3.data,
          _this$props3$children = _this$props3.children,
          children = _this$props3$children === void 0 ? [] : _this$props3$children;
      var sortOrder = this.props.sortFilters.sortOrder;

      if (sortBy !== currentSectionSort) {
        sortOrder = null;
      }

      if (header) {
        return _react["default"].Children.map(children, function (child) {
          return _react["default"].cloneElement(child, {
            handleClick: function handleClick() {
              return _this.updateSort();
            },
            sortOrder: sortOrder,
            sortable: true,
            // passing down data for Row generation
            header: header,
            data: data,
            headerText: headerText,
            type: type,
            sorted: sortBy === currentSectionSort
          });
        });
      }

      return _react["default"].Children.map(children, function (child) {
        return _react["default"].cloneElement(child, {
          // passing down data for Row generation
          header: header,
          data: data,
          rank: rank,
          headerText: headerText,
          type: type,
          highlighted: highlighted,
          sorted: sortBy === currentSectionSort
        });
      });
    }
  }]);

  return CellSorter;
}(_react.Component);

exports.CellSorter = CellSorter;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sortTable: function sortTable(sortBy, sortOrder, type) {
      return dispatch({
        type: type,
        sortFilters: {
          sortBy: sortBy,
          sortOrder: sortOrder,
          pageNum: 1
        }
      });
    }
  };
};

CellSorter.defaultProps = {
  sortFilters: {}
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(CellSorter);

exports["default"] = _default;

//# sourceMappingURL=CellSorter.js.map